export var BackgroundExportStatus;
(function (BackgroundExportStatus) {
    BackgroundExportStatus["Failed"] = "FAILED";
    BackgroundExportStatus["NoData"] = "NO_DATA";
    BackgroundExportStatus["Pending"] = "PENDING";
    BackgroundExportStatus["Completed"] = "COMPLETED";
})(BackgroundExportStatus || (BackgroundExportStatus = {}));
export var BackgroundExportTypes;
(function (BackgroundExportTypes) {
    BackgroundExportTypes["CashTransactionsReport"] = "CASH_TRANSACTIONS_REPORT";
    BackgroundExportTypes["InvestorSiteCashTransactionsReport"] = "INVESTOR_SITE_CASH_TRANSACTIONS_REPORT";
    BackgroundExportTypes["InvestmentTransactionsReport"] = "INVESTMENT_TRANSACTIONS_REPORT";
    BackgroundExportTypes["InvestorSiteInvestmentTransactionsReport"] = "INVESTOR_SITE_INVESTMENT_TRANSACTIONS_REPORT";
    BackgroundExportTypes["InvestmentHoldingsReport"] = "INVESTMENT_HOLDINGS_REPORT";
    BackgroundExportTypes["InvestmentExport"] = "INVESTMENTS_EXPORT";
    BackgroundExportTypes["ExitsExport"] = "EXITS_EXPORT";
    BackgroundExportTypes["AdviserStatementExport"] = "ADVISER_STATEMENT_EXPORT";
    BackgroundExportTypes["AdviserStatementExportAllFirms"] = "ADVISER_STATEMENT_EXPORT_ALL_FIRMS";
    BackgroundExportTypes["OrganisationStatementExport"] = "ORGANISATION_STATEMENT_EXPORT";
    BackgroundExportTypes["InvestorExport"] = "INVESTOR_EXPORT";
    BackgroundExportTypes["FeesExport"] = "FEES_EXPORT";
    BackgroundExportTypes["EisTasklistExport"] = "EIS_TASKLIST_EXPORT";
    BackgroundExportTypes["CompaniesExport"] = "COMPANIES_EXPORT";
    BackgroundExportTypes["AdvisersExport"] = "ADVISERS_EXPORT";
    BackgroundExportTypes["OrganisationsExport"] = "ORGANISATIONS_EXPORT";
    BackgroundExportTypes["BillingExport"] = "BILLING_EXPORT";
    BackgroundExportTypes["PortalUsageDataReport"] = "PORTAL_USAGE_DATA_REPORT";
    BackgroundExportTypes["TaxReportAuditExport"] = "TAX_REPORT_AUDIT_EXPORT";
})(BackgroundExportTypes || (BackgroundExportTypes = {}));
//# sourceMappingURL=index.js.map